module.exports = __webpack_public_path__ + "img/barrage_prize.e2db1dfd.png";